var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1669 5.09165C19.2081 3.89886 18.9472 2.715 18.4085 1.64999C18.043 1.21299 17.5358 0.918078 16.9752 0.816653C14.6565 0.606258 12.3281 0.520024 10.0002 0.55832C7.68072 0.518285 5.36078 0.601737 3.05019 0.80832C2.59337 0.891417 2.17062 1.10569 1.83352 1.42499C1.08352 2.11665 1.00019 3.29999 0.916852 4.29999C0.795945 6.09796 0.795945 7.90202 0.916852 9.69999C0.94096 10.2628 1.02476 10.8215 1.16685 11.3667C1.26733 11.7875 1.47062 12.1769 1.75852 12.5C2.09791 12.8362 2.53051 13.0627 3.00019 13.15C4.79678 13.3717 6.60703 13.4637 8.41685 13.425C11.3335 13.4667 13.8919 13.425 16.9169 13.1917C17.3981 13.1097 17.8428 12.8829 18.1919 12.5417C18.4252 12.3082 18.5994 12.0226 18.7002 11.7083C18.9982 10.7938 19.1446 9.83674 19.1335 8.87499C19.1669 8.40832 19.1669 5.59165 19.1669 5.09165ZM8.11685 9.37499V4.21665L13.0502 6.80832C11.6669 7.57499 9.84185 8.44165 8.11685 9.37499Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.181a09b0757ff35fec64cbb43c8b1c8d.svg";
export { ForwardRef as ReactComponent };